import React, { Component } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  InputGroup,
  Col,
  Form,
  Input,
  Row,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import styled from "styled-components";
import PropTypes from "prop-types";
import DefaultMultipleSelect from "../DefaultMultipleSelect/DefaultMultipleSelect";
import {
  getCurrentDay,
  getSelectedDaysAgo,
  getSelectedMonthAgo,
} from "../../helpers/utils";

class DynamicFormToFilterSplit extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { selectedDate } = this.props;
    this.setState({
      date: `${
        selectedDate !== null ? selectedDate.start_date : getSelectedMonthAgo(2)
      } to ${selectedDate !== null ? selectedDate.end_date : getCurrentDay()}`,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        ad_ids: this.props.data.ad_ids,
        campaign_ids: this.props.data.ad_ids,
        campaign_names: this.props.data.campaign_names,
      });
    }
  }

  handleSelect = (_, status, data) => {
    const { date } = this.state;

    const dateTime = {
      start_date: date.split(" ")[0],
      end_date: date.split(" ")[2] || getCurrentDay(),
    };

    if (date.split(" ")[2] !== undefined) {
      this.props.onFiltersChange("data", data, dateTime);
    }
  };

  onFiltersChange = date => {
    this.setState({ date });

    const data = {
      start_date: date.split(" ")[0],
      end_date: date.split(" ")[2] || getCurrentDay(),
    };

    if (date.split(" ")[2] !== undefined) {
      this.props.onFiltersChange("date", data);
    }
  };

  handleSelectedOffers = (_, status, data) => {
    const { offerTypes } = this.state;
    let dt = offerTypes.concat([]);

    for (let i in dt) {
      dt[i].checked = data.find(x => x.value == dt[i].id) !== undefined;
    }

    this.setState({
      offerTypes: dt,
    });

    this.handleFiltering();
  };

  render() {
    return (
      <StyledRow>
        <Col className="col-12">
          <StyledCard>
            <CardBody
              style={{
                padding: "1.25rem 0",
              }}
            >
              <Row className="justify-content-between">
                <Col xl={12} className="mb-1">
                  {this.props.filtersFields && (
                    <div className="col-sm-auto mb-2">
                      <span>Filter by: </span>
                    </div>
                  )}
                  <Form className="row gy-2 gx-3 ">
                    {this.props.filtersFields &&
                      this.props.filtersFields.map((i, key) => (
                        <div className="col-sm-auto" key={key}>
                          <DefaultMultipleSelect
                            options={
                              i.filterData?.length > 0
                                ? i.filterData.map((item, idx) => ({
                                    key: item.id || idx,
                                    text: item.name || item,
                                    checked: true,
                                  }))
                                : []
                            }
                            search
                            onChange={this.handleSelect}
                            plug={i.plug}
                          />
                        </div>
                      ))}
                    <div className="col-sm-auto">
                      <PickerStyled>
                        <Flatpickr
                          name="test"
                          value={this.state.date}
                          className="form-control d-block"
                          placeholder="Select date range..."
                          options={{
                            mode: "range",
                            dateFormat: "Y-m-d",
                          }}
                          onChange={(date, dateStr) =>
                            this.onFiltersChange(dateStr)
                          }
                        />
                      </PickerStyled>
                    </div>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </StyledCard>
        </Col>
      </StyledRow>
    );
  }
}

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

const PickerStyled = styled(InputGroup)`
  max-width: 240px;

  input {
    padding: 9px;
    font-size: 12px;
    background: #fff !important;
  }
`;

DynamicFormToFilterSplit.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  data: PropTypes.any,
  filtersFields: PropTypes.any,
  selectedDate: PropTypes.any,
  autoCheckedAll: PropTypes.bool,
};

export default DynamicFormToFilterSplit;
